module.exports = __webpack_public_path__ + "img/icon-impresora.6bee673b.svg";